<template>
  <div class="h-100">
    <div class="content-page p-3 pb-5 h-100">
      <b-row class="h-5">
        <b-col cols="12">
          <S040000Menu
            :t="t"
            :dictEnum="dictEnum"
            :isLeaveRecordVisible="
              hasRight('AlwRead', Settings.MenuID.StaffLeaveRecord)
            "
            :isStaffAttendanceVisible="
              hasRight('AlwRead', Settings.MenuID.StaffAttendance)
            "
            :isMonthlyVisible="
              hasRight('AlwRead', Settings.MenuID.MonthlyLeaveBalance)
            "
            :isOutdoorVisible="
              hasRight('AlwRead', Settings.MenuID.OutdoorWorkAllowance)
            "
            :isTaxReturnVisible="hasRight('AlwRead', Settings.MenuID.TaxReturn)"
          />
        </b-col>
      </b-row>
      <b-row class="h-10" align-v="center">
        <b-col cols="12">
          <b-row align-v="center">
            <b-col :cols="CompanyHide?'1':'2'">
              <b-form-select
                v-model="leaveType"
                id="inputState"
                class="form-control"
                style
              >
                <option value="" selected>
                  {{ this.t.t(dictEnum.LBL_SelectAll) }}
                </option>
                <option
                  v-for="option in leaveTypeList"
                  :key="option.LeaveType"
                  :value="option.LeaveType"
                >
                  {{ user.Lang == "EN" ? option.EDesc : option.CDesc }}
                </option>
              </b-form-select>
            </b-col>

            <b-col cols="2" class="text-center">
              <date-picker
                :placeholder="this.t.t(dictEnum.LBL_From)"
                v-model="DateFrom"
                :lang="lang"
                type="date"
                format="YYYY-MM-DD"
                v-bind:editable="false"
                v-bind:clearable="false"
                @change="getStaffList"
              ></date-picker>
            </b-col>
            <b-col cols="2" class="text-center">
              <date-picker
                v-model="DateTo"
                :placeholder="this.t.t(dictEnum.LBL_To)"
                :not-before="DateFrom"
                :lang="lang"
                format="YYYY-MM-DD"
                type="date"
                v-bind:editable="false"
                v-bind:clearable="false"
                @change="getStaffList"
              ></date-picker>
            </b-col>
            <b-col cols="2" v-if="CompanyHide">
              <b-form-select
                size="sm"
                v-model="selectedComp"
                @change="changeComp"
              >
                <option value selected>
                  --- {{ this.t.t(dictEnum.LBL_Company) }} ---
                </option>
                <option
                  v-for="(comp, index) in compList"
                  :key="index"
                  :value="comp.CompCode"
                >
                  {{ user.Lang == "EN" ? comp.EName : comp.CName }}
                </option>
              </b-form-select>
            </b-col>
            <b-col :cols="CompanyHide?'1':'2'">
              <b-form-select
                size="sm"
                v-model="selectedDept"
              >
              <option value selected>
                  --- {{ this.t.t(dictEnum.LBL_Department) }} ---
                </option>
                <option
                  v-for="(dept, index) in departmentList"
                  :key="index"
                  :value="dept.Dept"
                >
                  {{ user.Lang == "EN" ? dept.EDesc : dept.CDesc }}
                </option>
              </b-form-select>
            </b-col>
            <b-col cols="2">
              <!-- <select v-model="selectedStaff" class="form-control">
                <option value selected>
                  --- {{ this.t.t(dictEnum.LBL_SelectAll) }} ---
                </option>
                <option
                  v-for="option in StaffList"
                  v-bind:key="option.StaffID"
                  v-bind:value="option.StaffID"
                >
                  {{
                    user.Lang == "EN"
                      ? `${option.EngName} ${option.EngLastName}`
                      : `${option.ChiLastName}${option.ChiName}`
                  }}
                </option>
              </select> -->
              <div class="d-flex align-items-center input-mb-0">
                <v-text-field
                  :readonly="true"
                  style="margin-top: -12px"
                  class="form-input"
                  name="staff"
                  v-validate="{
                    required: true
                  }"
                  :placeholder="'--- ' + this.t.t(dictEnum.LBL_Staff) + ' ---'"
                  v-model="selectedStaff"
                ></v-text-field>
                <button
                  type="button"
                  class="btn btn-transparent p-1"
                  :disabled="false"
                  v-on:click="OnStaffBtnClick()"
                >
                  <img src="../../../static/images/search.png" class="w-14" />
                </button>
              </div>
            </b-col>

            <b-col cols="2" align-self="center" class="text-right">
              <button type="button" class="btn btn-info" @click="search">
                {{ this.t.t(dictEnum.LBL_Filter) }}
              </button>

              <download-excel
                class="btn btn-primary"
                :fetch="ExportTableData"
                v-if="hasRight('AlwExp', Settings.MenuID.StaffLeaveRecord)"
                :fields="columnsexport"
                type="xls"
                name="staffleaverecord.xls"
                :meta="[{ key: 'charset', value: 'utf-8' }]"
              >
                {{ this.t.t(dictEnum.BTN_Export) }}
              </download-excel>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="h-85">
        <b-col cols="12" class="h-100">
          <div class="tab-content bg-white h-100">
            <div
              class="tab-pane active table-responsive color-table h-90 overflow-y-auto"
            >
              <b-table
                class="tableRecord"
                :items="tableData"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
              >
                <template #head(Action)>
                  <font-awesome-icon
                    v-if="
                      selectedStaff &&
                        selectedStaff &&
                        hasRight(
                          Settings.Permission.Change,
                          Settings.MenuID.StaffLeaveRecord
                        ) &&
                        hasRight('AlwWrite', Settings.MenuID.StaffLeaveRecord)
                    "
                    v-b-modal.modal-adjustment
                    icon="plus"
                    style="cursor: pointer"
                    @click="initAdjustment"
                  />
                </template>
                <template #cell(UserName)="data">
                  <div>
                    {{ data.item.UserName }}
                  </div>
                </template>
                <template #cell(Date)="data">
                  {{ DateTimeFormat(data.item.Date) }}
                </template>
                <template #cell(DateFrom)="data">
                  {{ DateTimeFormat(data.item.DateFrom) }}
                </template>
                <!-- <template #cell(endDate)="data">
                  {{data.item.endDate}}
                </template> -->
                <template #cell(LeaveDesc)="data">
                  <div
                    v-b-tooltip
                    :title="data.item.LeaveDesc"
                    class="ellipsis"
                  >
                    {{ data.item.LeaveDesc }}
                  </div>
                </template>
                <template #cell(Action)="data">
                  <a
                    v-if="data.item.HaveAttachment"
                    href="javascript:void(0);"
                    class="pl-2"
                    v-on:click="onClickViewAttachment(data.item)"
                  >
                    <img src="../../../static/images/eye.png" class="w-14" />
                  </a>
                </template>
              </b-table>
            </div>
            <b-row
              no-gutters
              class="pt-3"
              style="position: absolute; bottom: 0"
            >
              <b-col cols="12">
                <b-pagination
                  first-number
                  last-number
                  limit="10"
                  v-model="currentPage"
                  :per-page="perPage"
                  :total-rows="tableData.length"
                ></b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </div>
    <b-modal
      id="modal-adjustment"
      :title="t.t(dictEnum.LBL_Adjustment)"
      :ok-title="t.t(dictEnum.BTN_Submit)"
      :cancel-title="t.t(dictEnum.BTN_Cancel)"
      @ok="addAdjustment"
    >
      <div class="p-3">
        <b-row class="my-1 no-gutters">
          <b-col cols="4">
            <b-input-group-prepend is-text>
              <span class="bg-white">{{ t.t(dictEnum.LBL_Date) }}</span>
            </b-input-group-prepend>
          </b-col>
          <b-col cols="7" class="mb-4">
            <date-picker
              :placeholder="this.t.t(dictEnum.LBL_From)"
              v-model="adjustment.DateTx"
              :lang="lang"
              type="date"
              format="YYYY-MM-DD"
              v-bind:editable="false"
              v-bind:clearable="false"
            ></date-picker>
          </b-col>
        </b-row>

        <b-row class="my-1 no-gutters">
          <b-col cols="4">
            <b-input-group-prepend is-text>
              <span class="bg-white">{{ t.t(dictEnum.LBL_LeaveType) }}</span>
            </b-input-group-prepend>
          </b-col>
          <b-col cols="7" class="mb-4">
            <b-form-select
              v-model="adjustment.LeaveType"
              :options="leaveTypeList"
              value-field="LeaveType"
              :text-field="user.Lang == 'EN' ? 'EDesc' : 'CDesc'"
            ></b-form-select>
          </b-col>
        </b-row>

        <b-row class="my-1 no-gutters">
          <b-col cols="4">
            <b-input-group-prepend is-text>
              <span class="bg-white">{{ t.t(dictEnum.LBL_Adjustment) }}</span>
            </b-input-group-prepend>
          </b-col>
          <b-col cols="2" class="pr-1">
            <b-form-group class="font-weight-normal">
              <b-form-select
                v-model="plusOrMinus.model"
                :options="plusOrMinus.data"
                value-field="value"
                text-field="name"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="2" class="pr-1">
            <b-form-group class="font-weight-normal">
              <b-form-input
                size="sm"
                maxlength="2"
                v-model="adjustment.QtyDaysHrs"
                @keypress="inputDigitOnly"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group class="font-weight-normal">
              <b-form-select
                v-model="dayHrsOption.model"
                :options="dayHrsOption.data"
                value-field="value"
                :text-field="user.Lang == 'EN' ? 'EDesc' : 'CDesc'"
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="my-1 no-gutters mt-3">
          <b-col cols="4">
            <b-input-group-prepend is-text>
              <span class="bg-white">{{ t.t(dictEnum.LBL_Description) }}</span>
            </b-input-group-prepend>
          </b-col>
          <b-col cols="7">
            <b-form-group class="font-weight-normal">
              <b-form-textarea
                v-model="adjustment.TxDesc"
                rows="4"
                max-rows="4"
                :formatter="formatDesc"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <div
      class="modal fade"
      id="staffModel"
      tabindex="-1"
      role="dialog"
      aria-labelledby="staffModel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered mw-820" role="document">
        <div class="modal-content list-modal">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              {{ t.t(dictEnum.LBL_StaffList) }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-search">
            <form class="form-inline">
              <div class="form-group mx-sm-3 mb-2 mt-2">
                <label for="inputPassword2" class="sr-only">search</label>
                <input
                  type="text"
                  class="form-control"
                  id="inputPassword2"
                  v-model="searchValue"
                  :placeholder="t.t(dictEnum.LBL_SearchStaff)"
                />
              </div>
            </form>
          </div>
          <div class="modal-body p-0">
            <v-simple-table
              class="table table-sm mb-0 modal-tbl"
              min-height="500"
              height="500"
            >
              <template>
                <thead>
                  <tr>
                    <th width="15%">
                      {{ t.t(dictEnum.LBL_StaffID) }}
                    </th>
                    <th width="20%">
                      {{ t.t(dictEnum.LBL_UserChiname) }}
                    </th>
                    <th width="20%">
                      {{ t.t(dictEnum.LBL_EngName) }}
                    </th>
                    <th width="20%">
                      {{ t.t(dictEnum.LBL_Job) }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in StaffList"
                    v-on:click="OnStaffSelect(item)"
                    :key="index"
                  >
                    <td width="15%">{{ item.StaffID }}</td>
                    <td width="20%">
                      {{ `${item.ChiLastName}${item.ChiName}` }}
                    </td>
                    <td width="20%">
                      {{ `${item.EngName} ${item.EngLastName}` }}
                    </td>
                    <td width="20%">
                      {{ `${item.JobTitle}` }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </div>
      </div>
    </div>
    <!-- Staff Modal End -->
    <b-modal
      id="modal-viewAttachment"
      :title="t.t(dictEnum.LBL_Attachment)"
      :ok-title="t.t(dictEnum.LBL_Download)"
      @ok="downloadAttachment"
    >
      <div class="p-2">
        <div class="row xs-gutters">
          <div v-for="(item, index) in selectedAttachmentList" :key="index">
            <span v-if="!item.IsDeleted" class="d-none">
              {{ (item.DocID = index + 1) }}
            </span>
            <div
              class="col-6"
              v-if="item.DocURL != null && item.DocURL != '' && !item.IsDeleted"
            >
              <div
                v-viewer
                v-if="
                  item.DocMime.indexOf('image/') > -1 &&
                    item.DocURL != null &&
                    item.DocURL != ''
                "
              >
                <img :src="item.DocURL" class="w-50" />
              </div>
              <a
                v-if="
                  item.DocMime.indexOf('image/') == -1 &&
                    item.DocURL != null &&
                    item.DocURL != ''
                "
                download
                :href="item.DocURL"
              >
                <img src="../../../static/images/document.png" class="w-20"
              /></a>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import moment from "moment";
import MenuRightSerivce from "@/service/MenuRightService";
import ReportService from "@/service/ReportService";
import UserService from "@/service/UserService";
import LeaveTypeService from "@/service/LeaveTypeService";
import $t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import SweetAlertService from "@/service/SweetAlertService";
import StoreGetter from "@/constants/StoreGetter";
import S040000Menu from "@/components/S040000-Report/S040000-Menu.vue";
import { Adjustment } from "@/model/Adjustment";
import InputHelper from "@/common/helper/InputHelper";
import { datePickerLang } from "@/constants/globalConstants";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import Settings from "../../constants/Settings";
import StaffService from "../../service/StaffService";
import ArrayHelper from "../../common/helper/ArrayHelper";
import StaffEmploymentService from "@/service/StaffEmploymentService";

export default {
  components: {
    DatePicker,
    moment,
    S040000Menu
  },
  data() {
    return {
      departmentList:[],//所有部门列表
      menuRights: { allRights: {}, rightsForThisMenu: {} },
      t: $t,
      dictEnum: dictEnum,
      Settings: Settings,
      menuId: Settings.MenuID.StaffLeaveRecord,
      adjustment: new Adjustment(),
      dayHrsOption: {
        model: "d",
        data: [
          { EDesc: "Days", CDesc: "日", value: "d" },
          { EDesc: "Hours", CDesc: "小時", value: "h" }
        ]
      },

      plusOrMinus: {
        model: "+",
        data: [
          {
            name: "+",
            value: "+"
          },
          { name: "-", value: "-" }
        ]
      },
      leaveTypeList: [],
      leaveType: "",
      staffList: [],
      searchValue: "",
      selectedStaff: "",
      selectedUserID: "",
      compList: [],
      selectedComp: "",
      selectedDept:"",
      BFBalance: null,
      CFBalance: null,
      columnsexport: {
        UserName: "UserName",
        DateJoin: "DateJoin",
        Dept: "Dept",
        StaffGrade: "StaffGrade",
        DateFrom: "DateFrom",
        endDate: "endDate",
        Function: "Function",
        LeaveDesc: "LeaveDesc",
        Addition: "Addition",
        Claimed: "Claimed",
        Balance: "Balance",
        Date: "Date"
      },
      dict: {},
      dictEnum: dictEnum,
      tableData: [],
      fields: [
        {
          key: "UserName",
          label: "",
          thStyle: "width:10%",
          thClass: "tableHeader"
        },
        {
          key: "DateJoin",
          label: $t.t(dictEnum.LBL_DateJoin),
          thStyle: "width:10%",
          thClass: "tableHeader"
        },
        {
          key: "Dept",
          label: $t.t(dictEnum.LBL_Department),
          thStyle: "width:10%",
          thClass: "tableHeader"
        },
        {
          key: "StaffGrade",
          label: $t.t(dictEnum.LBL_Title),
          thStyle: "width:10%",
          thClass: "tableHeader"
        },
        {
          key: "DateFrom",
          label: $t.t(dictEnum.LBL_StartDay),
          thStyle: "width:10%",
          thClass: "tableHeader"
        },
        {
          key: "endDate",
          label: $t.t(dictEnum.LBL_TermsDays),
          thStyle: "width:10%",
          thClass: "tableHeader  text-right",
           tdClass: "text-right"
        },
        {
          key: "Function",
          label: $t.t(dictEnum.LBL_LeaveType),
          thStyle: "width:10%",
          thClass: "tableHeader"
        },
        {
          key: "LeaveDesc",
          label: $t.t(dictEnum.LBL_Remark),
          thStyle: "width:25%",
          thClass: "tableHeader"
        },
        {
          key: "Addition",
          label: $t.t(dictEnum.LBL_Addition),
          thStyle: "width:10%",
          thClass: "tableHeader"
        },
        {
          key: "Claimed",
          label: $t.t(dictEnum.LBL_Claimed),
          thStyle: "width:10%",
          thClass: "tableHeader"
        },
        {
          key: "Balance",
          label: $t.t(dictEnum.LBL_Balance),
          thStyle: "width:10%",
          thClass: "tableHeader"
        },
        {
          key: "Date",
          label: $t.t(dictEnum.LBL_DateApply),
          thStyle: "width:10%;",
          thClass: "tableHeader"
        },
        {
          key: "Action",
          label: "",
          thStyle: "width:5%",
          thClass: "tableHeader"
        }
      ],
      currentPage: 1,
      perPage: 15,
      DateFrom: moment()
        .subtract(1, "months")
        .startOf("month")
        .toDate(),
      DateTo: moment()
        .startOf("day")
        .toDate(),
      // custom lang
      lang: datePickerLang,
      selectedLedger: {},
      selectedAttachmentList: [],
      CompanyHide:false
    };
  },
  computed: {
    user() {
      return this.$store.getters[StoreGetter.user];
    },
    userName() {
      return this.$store.getters[StoreGetter.user].Lang == "EN"
        ? this.$store.getters[StoreGetter.user].EngName
        : this.$store.getters[StoreGetter.user].ChiName;
    },
    StaffList() {
      let list = this.staffList;
      if (this.selectedComp) {
        list = list.filter(x => x.CompCode == this.selectedComp);
      }
      if (this.searchValue != "") {
        list = list.filter(x =>
          ArrayHelper.staffSearch(x, this.searchValue.toLowerCase())
        );
      }
      return list;
    }
  },
  methods: {
    setCompanyHide(){
    let user=this.$store.getters[StoreGetter.user].UserGrps;
    let sysParams = this.$store.getters[StoreGetter.sysParams];
    //定义需要查找的 ParamCode 值
    const paramCodes = ['HRADMIN', 'HRDEPT', 'ADMIN'];
    let combinedArray = [];
    paramCodes.forEach(paramCode => {
      let item = sysParams.find(item => item.ParamCode === paramCode);
      if (item && item.ParamVal) {
        combinedArray = combinedArray.concat(item.ParamVal.split(','));
      }
    });
    let uniqueArray = [...new Set(combinedArray)];
    // 判断 uniqueArray 中是否有与 user 中一致的数据
    this.CompanyHide = uniqueArray.some(value => user.includes(value));
    },
    hasRight(key, menuId) {
      if (Object.keys(this.menuRights.allRights).length === 0) {
        return false;
      } else {
        return MenuRightSerivce.hasRightInMenu(
          this.menuRights.allRights,
          menuId ? menuId : this.menuId,
          key
        );
      }
    },

    formatDesc(e) {
      return String(e).substring(0, 100);
    },

    async getPerPage() {
      const tableEle = await document.getElementsByClassName("tab-pane");
      const tableHeight = tableEle[0].offsetHeight;
      const trEle = tableEle[0].children[0].children;
      if (trEle.length > 1) {
        const thHeight = trEle[0].offsetHeight;
        const tdHeight = trEle[1].children[0].offsetHeight;
        let page = (tableHeight - thHeight * 2) / tdHeight;
        this.perPage = page.toFixed(0);
      }
    },

    DateTimeFormat(Date) {
      return Date ? moment(Date).format(Settings.DateTime.yyyymmddhhmm) : "";
    },

    assignRights() {
      this.menuRights.allRights = this.menuRights.allRights = this.$store.getters[
        StoreGetter.sysMenu
      ];
      this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
        x => x.MenuID == this.menuId
      );
    },
    async ExportTableData() {
      const sweetAlertOptions = {
        title: this.t.t(dictEnum.WARN_Confirm),
        text: this.t.t(dictEnum.MSG_ExportFile),
        cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
        confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
      };
      const result = await SweetAlertService.question(sweetAlertOptions);
      if (result.value) {
        const list = JSON.parse(JSON.stringify(this.tableData));
        list.forEach(rec => {
          let DateFrom = moment(rec.DateFrom).format(
            Settings.DateTime.yyyymmddhhmm
          );
          let Date = moment(rec.Date).format(Settings.DateTime.yyyymmddhhmm);
          rec.Date = Date == "0001-01-01" ? "" : Date ? Date : "";
          rec.DateFrom =
            DateFrom == "0001-01-01" ? "" : DateFrom ? DateFrom : "";
             // 如果 UserName 为空，则查找该 UserId 对应的其他记录，将 UserName 不为空的值赋给它
             if (!rec.UserName) {
              const nonEmptyUserName = list.find(r => r.UserId === rec.UserId && r.UserName);
                if (nonEmptyUserName) {
                  rec.UserName = nonEmptyUserName.UserName;
                }
              }
        });
        return list;
      }
    },
    inputDigitOnly(evt) {
      InputHelper.inputDigitOnly(evt);
    },

    changeComp() {
      this.selectedStaff = "";
      this.selectedUserID = "";
    },

    OnStaffBtnClick: function() {
      $("#staffModel").modal("show");
    },

    OnStaffSelect: function(model) {
      var self = this;
      if (self.$store.getters[StoreGetter.user].Lang == "EN") {
        self.selectedStaff = model["EngName"] + " " + model["EngLastName"];
      } else {
        self.selectedStaff = model["ChiLastName"] + model["ChiName"];
      }
      self.selectedUserID = model["StaffID"];
      $("#staffModel").modal("hide");
    },
    async search() {
      if (!this.DateFrom) {
        SweetAlertService.warning("Warn", this.t.t(dictEnum.WARN_Date));
        return;
      }
      if (!this.DateTo) {
        SweetAlertService.warning("Warn", this.t.t(dictEnum.WARN_Date));
        return;
      }

      const obj = {
        userId: this.selectedStaff ? this.selectedUserID : this.user.UserID,
        leaveType: this.leaveType,
        dateFrom: moment(this.DateFrom).format(Settings.DateTime.yyyymmddhhmm),
        dateTo: moment(this.DateTo).format(Settings.DateTime.yyyymmddhhmm),
        inclSubordinate: this.selectedStaff ? 0 : 1,
        compCode: this.selectedComp,
        dept: this.selectedDept
      };

      const response = await ReportService.getLeaveBalance(obj);
      if (response.data.IsSuccess) {
        let list = [];
        if (this.selectedComp) {
          response.data.Data = response.data.Data.filter(
            x => x.staff.CompCode == this.selectedComp
          );
        }
        response.data.Data.forEach(x =>{
          if(x.staffLeaveRecords.length>0){
              //补充员工假期记录的信息
              x.staffLeaveRecords.forEach((rec, recIndex) => {
            //职位名称
            rec.StaffGrade= x.staff.StaffEmploymentList[0].Title;
            //加入日期
            rec.DateJoin=x.staff.StaffEmploymentList[0].DateJoin;
            //加入部門
            this.departmentList.forEach(d => {
              if (d.Dept === x.staff.Dept) {
                rec.Dept=this.user.Lang == 'EN'?d.EDesc:d.CDesc;
              }
            });
              // 查找 CDesc 等于 rec.Function 的数据，并将 Days 赋值给 rec.endDate
        const leaveType = this.leaveTypeList.find(leaveType => leaveType.CDesc === rec.Function);
        if (leaveType) {
          if(leaveType.Days>0){
            rec.endDate = leaveType.Days;
          }else{
            rec.endDate = " ";
          }
        } 
            // //结束日期
            // let lastCharClaimed='';//递增
            // let lastCharAddition='';//递减
            // if(this.user.Lang == 'EN'){//判断递增或递减的单位是日还是小时数(中英区分截取)
            //   lastCharClaimed = rec.Claimed.slice(-2);
            //   lastCharAddition = rec.Addition.slice(-2);
            // }else{
            //   lastCharClaimed = rec.Claimed.slice(-1);
            //   lastCharAddition = rec.Addition.slice(-1);
            // }
            // //递增递减的数
            // let numberPart = rec.Addition.match(/\d+/);
            // let numberPart2 = rec.Claimed.match(/\d+/);
            // //假期日为单位时调用api获取结束日期
            // if(lastCharClaimed=='ys' || lastCharAddition=='ys' || lastCharClaimed=='日' ||lastCharAddition=='日'){
            //   const obj = {
            //     fromDate:moment(rec.DateFrom).format(Settings.DateTime.yyyymmdd),
            //     numberOfDays:numberPart?numberPart[0]:numberPart2[0]
            //   };
            //   UserService.getLeaveEndDate(obj).then(response=>{
            //     if(response.data.IsSuccess){
            //       rec.endDate=response.data.Data.endDate;//结束日期
            //     }
            //   });
            // }else{
            //   //半日或小时数为单位直接计算结束日期
            //   rec.endDate=moment(rec.DateFrom).add(numberPart?numberPart[0]:numberPart2[0], "hours").format(Settings.DateTime.yyyymmddhhmm);
            // }

            if (recIndex != 0) {
              rec.UserName = "";
            }
            if (
              this.leaveType == Settings.LeaveType.CL &&
              (recIndex == 0 || recIndex == x.staffLeaveRecords.length - 1)
            ) {
              rec.Date = "";
              rec.DateFrom = "";
            } else if (
              this.leaveType == Settings.LeaveType.AL &&
              (recIndex == 0 || recIndex == x.staffLeaveRecords.length - 2)
            ) {
              rec.Date = "";
              rec.DateFrom = "";
            }
            list.push(rec);
            return rec;
          });
          }
           } );
           setTimeout(() => {
            this.tableData = list;
           }, 500);
        this.getPerPage();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async addAdjustment() {
      if (!this.dayHrsOption.model) {
        SweetAlertService.warning("Warn", this.t.t(dictEnum.WARN_DaysOrHours));
        return;
      }
      if (this.adjustment.QtyDaysHrs <= 0) {
        SweetAlertService.warning(
          "Warn",
          this.t.t(dictEnum.WARN_HoursOutOfBound)
        );
        return;
      }
      if (
        this.dayHrsOption.model == "Hours" &&
        this.adjustment.QtyDaysHrs >= 8
      ) {
        SweetAlertService.warning(
          "Warn",
          this.t.t(dictEnum.WARN_HoursOutOfBound)
        );
        return;
      }

      if (!this.adjustment.QtyDaysHrs) {
        SweetAlertService.warning("Warn", this.t.t(dictEnum.WARN_DaysOrHours));
        return;
      }

      if (!this.adjustment.LeaveType) {
        SweetAlertService.warning(
          "Warn",
          this.t.t(dictEnum.MENU_LeaveType) + this.t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }
      const DateTx =
        moment(this.adjustment.DateTx).format(Settings.DateTime.yyyymmdd) +
        " 00:00:00";
      const obj = {
        UserID: this.selectedUserID,
        DateTx: DateTx,
        TxType: "ADJ",
        EventDesc: "",
        TxDesc: this.adjustment.TxDesc,
        LeaveType: this.adjustment.LeaveType,
        DaysAdd:
          this.dayHrsOption.model === "d" && this.plusOrMinus.model === "+"
            ? this.adjustment.QtyDaysHrs
            : 0,
        HoursAdd:
          this.dayHrsOption.model === "h" && this.plusOrMinus.model === "+"
            ? this.adjustment.QtyDaysHrs
            : 0,
        DaysDeduct:
          this.dayHrsOption.model === "d" && this.plusOrMinus.model === "-"
            ? this.adjustment.QtyDaysHrs
            : 0,
        HoursDeduct:
          this.dayHrsOption.model === "h" && this.plusOrMinus.model === "-"
            ? this.adjustment.QtyDaysHrs
            : 0,
        AddBy: this.$store.getters[StoreGetter.user].UserID
      };

      const response = await UserService.adjustLeave(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        if (this.leaveType) {
          this.search();
        }
      } else {
        this.adjustment = new Adjustment();
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async onClickViewAttachment(item) {
      this.selectedLedger = item;
      const obj = {
        txNum: item.TxNum,
        compCode: ""
      };
      const response = await UserService.getLeaveAttachments(obj);
      if (!response.data.IsSuccess) {
        SweetAlertService.warning("Warn", response.data.Message);
      } else {
        this.selectedAttachmentList = response.data.Data;
        this.$bvModal.show("modal-viewAttachment");
      }
    },

    downloadAttachment() {
      const zip = new JSZip();
      const self = this;
      if (this.selectedAttachmentList.length > 0) {
        for (const i in this.selectedAttachmentList) {
          const data = this.selectedAttachmentList[i];
          if (data.DocURL) {
            let type = "";
            if (data.DocMime.indexOf("jpg") > 0) {
              type = "jpg";
            } else if (data.DocMime.indexOf("jpeg") > 0) {
              type = "jpeg";
            } else if (data.DocMime.indexOf("png") > 0) {
              type = "png";
            } else if (data.DocMime.indexOf("pdf") > 0) {
              type = "pdf";
            } else if (
              data.DocMime ==
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            ) {
              type = "xlsx";
            } else if (data.DocMime.indexOf("xlsx") > 0) {
              type = "xlsx";
            } else if (data.DocMime.indexOf("xls") > 0) {
              type = "xls";
            } else if (data.DocMime.indexOf("text") > 0) {
              type = "txt";
            }
            zip.file(`${data.DocID}.${type}`, data.Doc, { base64: true });
          }
        }

        zip.generateAsync({ type: "blob" }).then(function(content) {
          saveAs(
            content,
            `${self.selectedLedger.UserName}_${
              self.selectedLedger.Function
            }_${moment(self.selectedLedger.DateFrom).format(
              Settings.DateTime.yyyymmddhhmm
            )}`
          );
        });
      }
    },

    async getLeaveTypeList() {
      const obj = {};
      const response = await LeaveTypeService.getLeaveTypes(obj);
      if (response.data.IsSuccess) {
        this.leaveTypeList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async getCompanyList() {
      const obj = {};
      const response = await StaffService.getAllCompany(obj);
      if (response.data.IsSuccess) {
        this.compList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async getStaffList() {
      const obj = {
        staffID: this.user.UserID,
        dateFrom: moment(this.DateFrom).format(Settings.DateTime.yyyymmdd),
        dateTo: moment(this.DateTo).format(Settings.DateTime.yyyymmdd)
      };
      const response = await StaffService.getStaffListOnDuty(obj);
      if (response.data.IsSuccess) {
        this.staffList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    initAdjustment() {
      this.adjustment = new Adjustment();
    },
    async getAllDepartment() {
      const obj = {};
      const response = await StaffEmploymentService.getAllDepartment(obj);
      if (response.data.IsSuccess) {
        this.departmentList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    }
  },
  mounted() {
    this.setCompanyHide();
    this.assignRights();
    this.getLeaveTypeList();
    this.getStaffList();
    this.getCompanyList();
    this.getAllDepartment();
  }
};
</script>
<style scoped lang="scss">
.text-right {
  text-align: right;
}
.mx-calendar-icon {
  width: 100%;
  height: auto !important;
  color: #555;
  stroke-width: 8px;
  stroke: currentColor;
  fill: currentColor;
}

.tableHeader {
  background: #5ba7be;
  position: sticky !important;
  top: 0;
}

.input-group-text {
  background: white;
  border: 0;
}

.tableRecord {
  table-layout: fixed;

  .ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/S040000-Report/S040100-StaffLeaveRecord.vue